import { render, staticRenderFns } from "./link-object-input.vue?vue&type=template&id=a263f13e&"
import script from "./link-object-input.vue?vue&type=script&lang=js&"
export * from "./link-object-input.vue?vue&type=script&lang=js&"
import style0 from "./link-object-input.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports